/** Patterns for internal catalog codes duplicated in parentheses — not trailing model numbers in titles. */
const SKU_IN_PARENS =
  /\s*[\(\（\[]\s*[A-Z0-9][A-Z0-9\-_\+\/\.]{2,}\s*[\)\）\]]/gi;

/** True when a value looks like an internal SKU / product code (not a customer-facing brand). */
export function isSkuLikeCode(value?: string | null): boolean {
  const v = (value ?? '').trim();
  if (!v) {
    return false;
  }

  if (/^\d{4,}$/.test(v)) {
    return true;
  }

  if (/^[A-Z]{2,6}[-_][A-Z0-9][A-Z0-9\-_+]*$/i.test(v)) {
    return true;
  }

  if (/^ZT[-_]/i.test(v)) {
    return true;
  }

  return false;
}

/** Remove parenthetical internal SKU codes only — keeps model numbers like "JR-PBM01" in titles. */
export function stripSkuFromDisplayText(text?: string | null): string {
  if (!text?.trim()) {
    return '';
  }

  const original = text.trim();
  let result = original.replace(SKU_IN_PARENS, ' ');
  result = result.replace(/\s{2,}/g, ' ').replace(/\s+لـ\s*\.{3}\s*$/i, '').trim();
  return result || original;
}

/** Brand label for PDP / filters — hides SKU-derived codes. */
export function getDisplayBrand(brand?: string | null, fallback = 'ZeroTech'): string {
  const trimmed = (brand ?? '').trim();
  if (!trimmed || isSkuLikeCode(trimmed)) {
    return fallback;
  }

  return trimmed;
}

/** Whether a brand value should appear in catalog filters. */
export function isCustomerFacingBrand(brand?: string | null): boolean {
  const trimmed = (brand ?? '').trim();
  return !!trimmed && !isSkuLikeCode(trimmed);
}

/** Whether a product passes the active brand filter (products without a brand always pass). */
export function productMatchesBrandFilter(
  brandLabel: string,
  selectedBrands: ReadonlySet<string>
): boolean {
  if (selectedBrands.size === 0) {
    return true;
  }

  return !brandLabel || selectedBrands.has(brandLabel);
}
